import { render, staticRenderFns } from "./SaasXml.vue?vue&type=template&id=341a3c46"
import script from "./SaasXml.vue?vue&type=script&lang=js"
export * from "./SaasXml.vue?vue&type=script&lang=js"
import style0 from "./SaasXml.vue?vue&type=style&index=0&id=341a3c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports